import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SvgNmrSameTop, SvgNmrResetScale } from 'cheminfo-font';
import { memo, useCallback } from 'react';
import { FaCreativeCommonsSamplingPlus, FaEye, FaEyeSlash, } from 'react-icons/fa';
import { IoColorPaletteOutline } from 'react-icons/io5';
import { useChartData } from '../../context/ChartContext';
import { useDispatch } from '../../context/DispatchContext';
import Button from '../../elements/Button';
import { useAlert } from '../../elements/popup/Alert';
import { useModal } from '../../elements/popup/Modal';
import { useActiveSpectra } from '../../hooks/useActiveSpectra';
import useSpectrum from '../../hooks/useSpectrum';
import { DISPLAYER_MODE } from '../../reducer/core/Constants';
import { ADD_MISSING_PROJECTION, CHANGE_VISIBILITY, DELETE_SPECTRA, RECOLOR_SPECTRA_COLOR, RESET_SPECTRA_SCALE, SET_SPECTRA_SAME_TOP, } from '../../reducer/types/Types';
import { getSpectraByNucleus } from '../../utility/getSpectraByNucleus';
import DefaultPanelHeader from '../header/DefaultPanelHeader';
import { SpectraAutomaticPickingButton } from '../header/SpectraAutomaticPickingButton';
function getMissingProjection(SpectrumsData, activeTab) {
    let nucleus = activeTab.split(',');
    nucleus = nucleus[0] === nucleus[1] ? [nucleus[0]] : nucleus;
    const missingNucleus = [];
    for (const n of nucleus) {
        const hasSpectrums = SpectrumsData.some((d) => d.info.nucleus === n);
        if (!hasSpectrums) {
            missingNucleus.push(n);
        }
    }
    return missingNucleus;
}
function SpectraPanelHeaderInner({ data, activeSpectrum, activeSpectra, activeTab, displayerMode, onSettingClick, }) {
    const modal = useModal();
    const alert = useAlert();
    const dispatch = useDispatch();
    const spectra = getSpectraByNucleus(activeTab, data);
    const handleDelete = useCallback(() => {
        modal.showConfirmDialog({
            message: (_jsxs("span", { children: ["You are about to delete", _jsxs("span", { style: { color: 'black' }, children: [" ", activeSpectra?.length, " "] }), "spectra, Are you sure?"] })),
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        dispatch({ type: DELETE_SPECTRA });
                    },
                },
                { text: 'No' },
            ],
        });
    }, [activeSpectra?.length, dispatch, modal]);
    function showAllSpectrumsHandler() {
        dispatch({
            type: CHANGE_VISIBILITY,
            payload: { nucleus: activeTab, flag: true },
        });
    }
    function hideAllSpectrumsHandler() {
        dispatch({
            type: CHANGE_VISIBILITY,
            payload: { nucleus: activeTab, flag: false },
        });
    }
    function addMissingProjectionHandler() {
        const missingNucleus = getMissingProjection(data, activeTab);
        if (missingNucleus.length > 0) {
            dispatch({ type: ADD_MISSING_PROJECTION, nucleus: missingNucleus });
        }
        else {
            alert.error('Nothing to calculate');
        }
    }
    function setSameTopHandler() {
        dispatch({ type: SET_SPECTRA_SAME_TOP });
    }
    function resetScaleHandler() {
        dispatch({ type: RESET_SPECTRA_SCALE });
    }
    function recolorSpectraHandler() {
        dispatch({
            type: RECOLOR_SPECTRA_COLOR,
            payload: {},
        });
    }
    const hasActiveSpectra = activeSpectra && activeSpectra?.length > 0;
    return (_jsxs(DefaultPanelHeader, { onDelete: handleDelete, counter: spectra?.length, deleteToolTip: "Delete selected spectra", disableDelete: !hasActiveSpectra, showSettingButton: true, onSettingClick: onSettingClick, children: [_jsx(Button.BarButton, { toolTip: "Hide selected spectra", onClick: hideAllSpectrumsHandler, tooltipOrientation: "horizontal", disabled: !hasActiveSpectra, children: _jsx(FaEyeSlash, {}) }), _jsx(Button.BarButton, { onClick: showAllSpectrumsHandler, toolTip: "Show selected spectra", tooltipOrientation: "horizontal", disabled: !hasActiveSpectra, children: _jsx(FaEye, {}) }), displayerMode === DISPLAYER_MODE.DM_2D && activeSpectrum?.info.isFt && (_jsx(Button.BarButton, { toolTip: "Add missing projection", tooltipOrientation: "horizontal", onClick: addMissingProjectionHandler, children: _jsx(FaCreativeCommonsSamplingPlus, {}) })), displayerMode === DISPLAYER_MODE.DM_1D && spectra.length > 1 && (_jsxs(_Fragment, { children: [_jsx(Button.BarButton, { tooltipOrientation: "horizontal", toolTip: "Reset Scale", onClick: resetScaleHandler, children: _jsx(SvgNmrResetScale, {}) }), _jsx(Button.BarButton, { tooltipOrientation: "horizontal", toolTip: "Same Top", onClick: setSameTopHandler, children: _jsx(SvgNmrSameTop, {}) })] })), _jsx(SpectraAutomaticPickingButton, {}), _jsx(Button.BarButton, { tooltipOrientation: "horizontal", toolTip: "Recolor spectra", onClick: recolorSpectraHandler, children: _jsx(IoColorPaletteOutline, {}) })] }));
}
const MemoizedSpectraPanelHeader = memo(SpectraPanelHeaderInner);
export default function SpectrumsTabs({ onSettingClick, }) {
    const { data, view: { spectra: { activeTab }, }, displayerMode, } = useChartData();
    const spectrum = useSpectrum();
    const activeSpectra = useActiveSpectra();
    return (_jsx(MemoizedSpectraPanelHeader, { ...{
            data,
            activeSpectrum: spectrum,
            activeSpectra,
            activeTab,
            displayerMode,
            onSettingClick,
        } }));
}
